import { uniqueId } from "lodash";
import { Moment } from "moment";
import SearchAutocomplete from "../../../../form/searchAutocomplete";
import { fetchParts } from "../../../../../api/fetchParts";
import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";
import { Button, DatePicker, Select } from "@rio-cloud/rio-uikit";
import { IChildForm } from "../../../";
import { useIntl } from "react-intl";

export const PartsChildForm = (props: IChildForm) => {
    const intl = useIntl();
    return (
        <>
            <div
                className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
                    }`}
            >
                {props.hiddenFields.includes("partOrderStatus") ? null : (
                    <div
                        className={`form-group form-group-lg w-full ${props.hasError &&
                            props.requiredFields.includes("partOrderStatus") &&
                            !props.occurrence?.partOrderStatus
                            ? "has-error"
                            : ""
                            }`}
                    >
                        <label htmlFor="partOrderStatus" className="truncate">
                            {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.partsStatus" })}
                            {props.requiredFields.includes("partOrderStatus") ? " *" : ""}
                        </label>
                        <input
                            id="partOrderStatus"
                            className="form-control"
                            value={props.occurrence?.partOrderStatus}
                            onChange={(e) => {
                                if (props.occurrence) {
                                    props.setOccurrenceValue("partOrderStatus", e.target.value);
                                    
                                    if (e.target.value.trim() !== "" && 
                                        (!props.occurrence.partOrderDeliveryDates || props.occurrence.partOrderDeliveryDates.length === 0)) {
                                        props.setOccurrenceValue("partOrderDeliveryDates", [
                                            {
                                                id: uniqueId(),
                                                expected: null,
                                                delivered: null,
                                            }
                                        ]);
                                    }
                                }
                            }}
                            disabled={
                                props.disabledAllFields ||
                                props.disabledFields.includes("partOrderStatus")
                            }
                            maxLength={5000}
                        />
                    </div>
                )}
            </div>

            {props.hiddenFields.includes("partOrderNumber") ? null : (
                <div id="part-orders-container" className={`${(props.disabledAllFields || props.disabledFields.includes("partOrderNumber")) && (props.occurrence?.partOrders?.length ?? 0) === 0 ? "hidden" : "relative border border-gray-300 dark:border-neutral-700 rounded-md px-4 py-8 my-10"}`}>
                    <div className="absolute -top-3 left-4 bg-white dark:bg-neutral-900 px-2 text-gray-600 dark:text-neutral-400 font-medium">
                        {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.partOrders" })}
                    </div>
                    {(props.occurrence?.partOrders ?? []).map(
                        (partOrder: any, index: number) => (
                            <div
                                className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
                                    }`}
                            >
                                {props.hiddenFields.includes("partOrderNumber") ? null : (
                                    <div
                                        className={`form-group form-group-lg w-full ${props.hasError && !partOrder.number ? "has-error" : ""
                                            }`}
                                    >
                                        {index === 0 ? (
                                            <label htmlFor="partOrderNumber" className="truncate">
                                                {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.orderNumberRequired" })}
                                            </label>
                                        ) : null}
                                        <input
                                            id="partOrderNumber"
                                            className="form-control"
                                            placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.orderNumber" })}
                                            value={partOrder.number}
                                            onChange={(e) => {
                                                if (!/^\d+$/.test(e.target.value)) return;
                                                
                                                const newPartOrders = [
                                                    ...(props.occurrence?.partOrders ?? []),
                                                ];
                                                newPartOrders[index] = {
                                                    ...partOrder,
                                                    number: e.target.value,
                                                };
                                                props.occurrence &&
                                                    props.setOccurrenceValue(
                                                        "partOrders",
                                                        newPartOrders
                                                    );
                                            }}
                                            disabled={
                                                props.disabledAllFields ||
                                                props.disabledFields.includes("partOrderNumber")
                                            }
                                            maxLength={100}
                                        />
                                    </div>
                                )}
                                {props.hiddenFields.includes(
                                    "partOrderStatusOrder"
                                ) ? null : (
                                    <div
                                        className={`form-group form-group-lg w-full ${props.hasError && !partOrder.status ? "has-error" : ""
                                            }`}
                                    >
                                        {index === 0 ? (
                                            <label
                                                htmlFor="partOrderStatusOrder"
                                                className="truncate"
                                            >
                                                {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.orderStatus" })}
                                            </label>
                                        ) : null}
                                        <Select
                                            id="partOrderStatusOrder"
                                            placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.orderStatus" })}
                                            options={[
                                                { id: 'B.O.', label: 'B.O.' },
                                                { id: 'DSH', label: 'DSH' },
                                                { id: 'Estoque', label: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.statusStock" }) },
                                                { id: 'Unidade Parada', label: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.statusUnitStopped" }) },
                                                { id: 'Disponível', label: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.statusAvailable" }) },
                                                { id: 'Livre de Débito', label: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.statusDebtFree" }) },
                                            ]}
                                            value={partOrder.status ? [partOrder.status] : []}
                                            onChange={(selected) => {
                                                const newPartOrders = [
                                                    ...(props.occurrence?.partOrders ?? []),
                                                ];
                                                newPartOrders[index] = {
                                                    ...partOrder,
                                                    status: selected?.id || '',
                                                };
                                                props.occurrence &&
                                                    props.setOccurrenceValue(
                                                        "partOrders",
                                                        newPartOrders
                                                    );
                                            }}
                                            disabled={
                                                props.disabledAllFields ||
                                                props.disabledFields.includes("partOrderStatusOrder")
                                            }
                                        />
                                    </div>
                                )}

                                <div
                                    className={`form-group form-group-lg w-full ${props.hasError && !partOrder.date ? "has-error" : ""
                                        }`}
                                >
                                    {index === 0 ? (
                                        <label htmlFor="partOrderDtOrder" className="truncate">
                                            {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.partOrderDateRequired" })}
                                        </label>
                                    ) : null}
                                    {props.disabledAllFields ||
                                        props.disabledFields.includes("partOrderDtOrder") ? (
                                        <input
                                            id="partOrderDtOrder"
                                            className="form-control"
                                            value={partOrder.date?.toLocaleDateString(intl.locale)}
                                            disabled={true}
                                            placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.partOrderDate" })}
                                        />
                                    ) : (
                                        <DatePicker
                                            id="partOrderDtOrder"
                                            inputProps={{ placeholder: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.partOrderDate" }) }}
                                            className="pb-0 mb-0"
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat={false}
                                            locale={intl.locale}
                                            value={partOrder.date}
                                            onChange={(result: Moment | string) => {
                                                const newPartOrders = [
                                                    ...(props.occurrence?.partOrders ?? []),
                                                ];
                                                newPartOrders[index] = {
                                                    ...partOrder,
                                                    date: new Date(result as string),
                                                };
                                                props.occurrence &&
                                                    props.setOccurrenceValue(
                                                        "partOrders",
                                                        newPartOrders
                                                    );
                                            }}
                                        />
                                    )}
                                </div>

                                {props.disabledAllFields ||
                                    props.disabledFields.includes("partOrders") ? null : (
                                    <div className="form-group form-group-lg">
                                        <div
                                            className='text-color-info cursor-pointer text-size-18 w-full h-full'
                                            style={{
                                                paddingTop: index == 0 ? 40 : 8,
                                            }}
                                            onClick={() =>
                                                props.occurrence &&
                                                props.setOccurrenceValue(
                                                    "partOrders",
                                                    (props.occurrence?.partOrders ?? []).filter(
                                                        (p) => p.id !== partOrder.id
                                                    )
                                                )
                                            }
                                        >
                                            <span className="rioglyph rioglyph-trash text-color-info" />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    )}

                    {props.disabledAllFields ||
                        props.disabledFields.includes("partOrderNumber") ? null : (
                        <Button
                            bsStyle={Button.PRIMARY}
                            className="padding-top-10 flex items-center gap-2 cursor-pointer ml-2"
                            onClick={() => {
                                props.occurrence &&
                                    props.setOccurrenceValue("partOrders", [
                                        ...(props.occurrence?.partOrders ?? []),
                                        {
                                            id: uniqueId(),
                                            number: "",
                                            status: "",
                                            date: null,
                                        },
                                    ]);
                            }}
                        >
                            <span className="rioglyph rioglyph-plus-sign"></span>
                            <span className="font-bold">
                                {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.addPartOrder" })}
                            </span>
                        </Button>
                    )}
                </div>
            )}

            {props.hiddenFields.includes("partOrderParts") ? null : (
                <div id="part-order-parts-container" className={`${(props.disabledAllFields || props.disabledFields.includes("partOrderParts")) && (props.occurrence?.partOrders?.length ?? 0) === 0 ? "hidden" : "relative border border-gray-300 dark:border-neutral-700 rounded-md px-4 py-8 my-10"}`}>
                    <div className="absolute -top-3 left-4 bg-white dark:bg-neutral-900 px-2 text-gray-600 dark:text-neutral-400 font-medium">
                        {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.parts" })}
                    </div>
                    {(props.occurrence?.partOrderParts ?? []).map(
                        (part: any, index: number) => (
                            <div
                                key={index}
                                className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
                                    }`}
                            >
                                <div
                                    className={`form-group form-group-lg w-full ${props.hasError && !part.partNumber ? "has-error" : ""
                                        }`}
                                >
                                    {index === 0 ? (
                                        <label htmlFor="partNumber" className="truncate">
                                            {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.part" })}
                                            {props.requiredFields.includes("partNumber")
                                                ? " *"
                                                : ""}
                                        </label>
                                    ) : null}
                                    <SearchAutocomplete
                                        id="partNumber"
                                        defaultValue={part.partNumber}
                                        placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.selectPart" })}
                                        fetchOptions={fetchParts}
                                        optionLabel={
                                            props.persona === "MANAGER"
                                                ? { description: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.optionDescription" }) }
                                                : { code: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.optionCode" }), description: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.optionDescription" }) }
                                        }
                                        onSelectedOption={(e: any) => {
                                            const newParts = [
                                                ...(props.occurrence?.partOrderParts ?? []),
                                            ];
                                            newParts[index] = {
                                                ...part,
                                                id: e?.code,
                                                partNumber: e,
                                            };
                                            props.occurrence &&
                                                props.setOccurrenceValue("partOrderParts", newParts);
                                        }}
                                        disabled={
                                            props.disabledAllFields ||
                                            props.disabledFields.includes("partOrderParts")
                                        }
                                        allowManualAdd={true}
                                    />
                                </div>

                                <div
                                    className={`form-group form-group-lg w-full ${props.hasError && !part.quantity ? "has-error" : ""
                                        }`}
                                >
                                    {index === 0 ? (
                                        <label htmlFor="quantity" className="truncate">
                                            {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.quantityRequired" })}
                                        </label>
                                    ) : null}
                                    <input
                                        id="quantity"
                                        className="form-control"
                                        value={part.quantity}
                                        onChange={(e) => {
                                            if (!/^\d+$/.test(e.target.value)) return;
                                            
                                            const newParts = [
                                                ...(props.occurrence?.partOrderParts ?? []),
                                            ];
                                            newParts[index] = {
                                                ...part,
                                                quantity: e.target.value,
                                            };
                                            props.occurrence &&
                                                props.setOccurrenceValue("partOrderParts", newParts);
                                        }}
                                        disabled={
                                            props.disabledAllFields ||
                                            props.disabledFields.includes("partOrderParts")
                                        }
                                        placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.quantity" })}
                                        maxLength={100}
                                    />
                                </div>

                                {props.disabledAllFields ||
                                    props.disabledFields.includes("partOrderParts") ? null : (
                                    <div className="form-group form-group-lg">
                                        <div
                                            className='text-color-info cursor-pointer text-size-18 w-full h-full'
                                            style={{
                                                paddingTop: index == 0 ? 40 : 8,
                                            }}
                                            onClick={() =>
                                                props.occurrence &&
                                                props.setOccurrenceValue(
                                                    "partOrderParts",
                                                    (props.occurrence?.partOrderParts ?? []).filter(
                                                        (p) => p.id !== part.id
                                                    )
                                                )
                                            }
                                        >
                                            <span className="rioglyph rioglyph-trash text-color-info" />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    )}

                    {props.disabledAllFields ||
                        props.disabledFields.includes("partOrderParts") ? null : (
                        <Button
                            bsStyle={Button.PRIMARY}
                            className="padding-top-10 flex items-center gap-2 cursor-pointer ml-2"
                            onClick={() =>
                                props.occurrence &&
                                props.setOccurrenceValue("partOrderParts", [
                                    ...(props.occurrence?.partOrderParts ?? []),
                                    {
                                        id: uniqueId(),
                                        partNumber: "",
                                        quantity: "",
                                    },
                                ])
                            }
                        >
                            <span className="rioglyph rioglyph-plus-sign"></span>
                            <span className="font-bold">
                                {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.addPart" })}
                            </span>
                        </Button>
                    )}
                </div>
            )}

            {props.hiddenFields.includes("partOrderDtEstimate") ? null : (
                <div id="part-order-delivery-dates-container" className={`${(props.disabledAllFields || props.disabledFields.includes("partOrderDtEstimate")) && (props.occurrence?.partOrderDeliveryDates?.length ?? 0) === 0 ? "hidden" : "relative border border-gray-300 dark:border-neutral-700 rounded-md px-4 py-8 my-10"}`}>
                    <div className="absolute -top-3 left-4 bg-white dark:bg-neutral-900 px-2 text-gray-600 dark:text-neutral-400 font-medium">
                        {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.deliveryDates" })}
                        {props.occurrence?.partOrderStatus && props.occurrence.partOrderStatus.trim() !== "" ? (
                            <span className="text-color-status-active"> {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.forecastRequired" })}</span>
                        ) : ""}
                    </div>
                    {props.occurrence?.partOrderDeliveryDates?.map((part: any, index: number) => (
                        <div
                            key={index}
                            className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
                                }`}
                        >
                            <div className="form-group form-group-lg w-full">
                                {index === 0 ? (
                                    <label htmlFor="partOrderDtEstimate" className="truncate">
                                        {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.expectedDeliveryDate" })}
                                    </label>
                                ) : null}
                                {props.disabledAllFields ||
                                    props.disabledFields.includes("partOrderDtEstimate") ? (
                                    <input
                                        id="partOrderDtEstimate"
                                        className="form-control"
                                        value={part.expected?.toLocaleDateString(intl.locale)}
                                        disabled={true}
                                    />
                                ) : (
                                    <DatePicker
                                        id="partOrderDtEstimate"
                                        inputProps={{
                                            placeholder: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.expectedDeliveryDate" }),
                                        }}
                                        className="pb-0 mb-0"
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        locale={intl.locale}
                                        value={part.expected}
                                        onChange={(result: Moment | string) => {
                                            const newPartOrderDeliveryDates = [
                                                ...(props.occurrence?.partOrderDeliveryDates ?? []),
                                            ];
                                            newPartOrderDeliveryDates[index] = {
                                                ...part,
                                                expected: new Date(result as string),
                                            };
                                            props.occurrence &&
                                                props.setOccurrenceValue(
                                                    "partOrderDeliveryDates",
                                                    newPartOrderDeliveryDates
                                                );
                                        }}
                                    />
                                )}
                            </div>

                            <div className="form-group form-group-lg w-full">
                                {index === 0 ? (
                                    <label htmlFor="partOrderDtDelivery" className="truncate">
                                        {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.deliveryDate" })}
                                    </label>
                                ) : null}
                                {props.disabledAllFields ||
                                    props.disabledFields.includes("partOrderDtDeliveryEstimate") ? (
                                    <input
                                        id="partOrderDtDelivery"
                                        className="form-control"
                                        value={part.delivered?.toLocaleDateString(intl.locale)}
                                        disabled={true}
                                    />
                                ) : (
                                    <DatePicker
                                        id="partOrderDtDelivery"
                                        inputProps={{
                                            placeholder: intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.deliveryDate" }),
                                        }}
                                        className="pb-0 mb-0"
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        locale={intl.locale}
                                        value={part.delivered}
                                        onChange={(result: Moment | string) => {
                                            const newPartOrderDeliveryDates = [
                                                ...(props.occurrence?.partOrderDeliveryDates ?? []),
                                            ];
                                            newPartOrderDeliveryDates[index] = {
                                                ...part,
                                                delivered: new Date(result as string),
                                            };
                                            props.occurrence &&
                                                props.setOccurrenceValue(
                                                    "partOrderDeliveryDates",
                                                    newPartOrderDeliveryDates
                                                );
                                        }}
                                    />
                                )}
                            </div>

                            {props.disabledAllFields ||
                                props.disabledFields.includes("partOrderDtEstimate") ? null : (
                                <div className="form-group form-group-lg">
                                    <div
                                        className='text-color-info cursor-pointer text-size-18 w-full h-full'
                                        style={{
                                            paddingTop: index == 0 ? 40 : 8,
                                        }}
                                        onClick={() =>
                                            props.occurrence &&
                                            props.setOccurrenceValue(
                                                "partOrderDeliveryDates",
                                                (props.occurrence?.partOrderDeliveryDates ?? []).filter(
                                                    (p) => p.id !== part.id
                                                )
                                            )
                                        }
                                    >
                                        <span className="rioglyph rioglyph-trash text-color-info" />
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}

                    {props.disabledAllFields ||
                        props.disabledFields.includes("partOrderDtEstimate") ? null : (
                        <Button
                            bsStyle={Button.PRIMARY}
                            className="padding-top-10 flex items-center gap-2 cursor-pointer ml-2"
                            onClick={() =>
                                props.occurrence &&
                                props.setOccurrenceValue("partOrderDeliveryDates", [
                                    ...(props.occurrence?.partOrderDeliveryDates ?? []),
                                    {
                                        id: uniqueId(),
                                        expected: null,
                                        delivered: null,
                                    },
                                ])
                            }
                        >
                            <span className="rioglyph rioglyph-plus-sign"></span>
                            <span className="font-bold">
                                {intl.formatMessage({ id: "intl-msg:kanban.form.partsChildForm.addDeliveryDate" })}
                            </span>
                        </Button>
                    )}
                </div>
            )}
        </>
    );
};